import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Handle, useNodeConnections, useInternalNode, useNodeId } from '@xyflow/react';
import { Box } from '@chakra-ui/react';
import { RFTooltipInner } from '../../base';
/**
 * Component renders when a handle of ReactFlow node
 * @param props : props inherits from HandleProps.
 */
const RFHandleFC = ({ id, type, name, style, position, isInspector, isConnectable, connectionCount }) => {
    const nodeId = useNodeId();
    const [isTooltip, setIsTooltip] = useState(false);
    const internalNode = useInternalNode(nodeId ?? '');
    const connections = useNodeConnections({ handleId: id ?? '', handleType: type, id: nodeId ?? '' });
    const canConnect = isConnectable && connections.length < connectionCount;
    const bounds = internalNode?.internals?.handleBounds?.[type]?.find((h) => h.id === id);
    const renderTooltipContent = () => {
        if (!isInspector) {
            return _jsx(_Fragment, { children: name });
        }
        return (_jsxs(Box, { fontFamily: "ptmono", children: [_jsxs(Box, { className: "cut-text", children: ["port_name: ", name] }), _jsxs(Box, { className: "cut-text", children: ["port_code: ", id] }), _jsxs(Box, { className: "cut-text", children: ["port_type: ", connectionCount > 1 ? 'multi' : 'single'] })] }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(Handle, { id: id, type: type, style: style, position: position, isConnectable: canConnect, onMouseEnter: () => setIsTooltip(true), onMouseLeave: () => setIsTooltip(false) }), !canConnect && (_jsx(Box, { position: 'absolute', onMouseEnter: () => setIsTooltip(true), onMouseLeave: () => setIsTooltip(false), style: { width: '6px', height: '6px', top: bounds?.y, left: bounds?.x, zIndex: 1 } })), isTooltip && bounds && (_jsx(Box, { position: 'absolute', whiteSpace: 'nowrap', zIndex: 2, style: {
                    transform: 'translateX(-50%)',
                    top: bounds.y - (isInspector ? 80 : 35),
                    left: bounds.x
                }, children: _jsx(RFTooltipInner, { msg: renderTooltipContent() }) }))] }));
};
export const RFHandle = RFHandleFC;
//# sourceMappingURL=RFHandle.js.map